<div class="theme_bg">
<div class="container nopad">
    <app-booking-steps [travellers]="true" [passengerDetails]="true" [review]="true"></app-booking-steps>
    <div class="row mobile_row" #gotoBaggageProtection>
        <div class="col-md-12">
        <app-booking-flight-detail *ngIf="flight" [flight]="flight" [traveller]="traveller"></app-booking-flight-detail>
        </div>
        <div class="col-md-8 pl-0 mb-5 mobile_pad">
            <div class="card mt-3" style="box-shadow: 0px 1px 16px #ddd;"  *ngIf="!currentUser">
                <div class="card-body">
                    <h5 class="card-title">Log in or register to enjoy this member-only benifit</h5>
                    <a class="card-link" style="color: #189AD3;" data-toggle="modal" data-target="#show_log"
                       >Log In or Register</a>
                </div>
            </div>
            <div class="clearfix"></div>
            <h3 class="inpagehed">Contact Details</h3>
            <div class="card p-3 sectionbuk">
                <div class="row">
                    <div class="col-12 d-flex w-100 justify-content-between capitalize">
                        <h5 class="mb-1">{{ contact.Title +' '+ contact.FirstName +' '+contact.MiddleName+' '+contact.LastName}}</h5>
                        <button type="button" class="btn btn-link" (click)="editPassengers()">Edit</button>
                    </div>
                    <hr class="my-2 w-100">
                    <div class="col-md-4 col-12">
                        <label>Mobile Number</label>
                        <p>{{ contact.phoneExtensionCode }} {{ contact.phoneNumber }}</p>
                    </div>
                    <div class="col-md-4 col-12 align-items-end">
                        <label>Email</label>
                        <p>{{ contact.email }}</p>
                    </div>

                </div>
            </div>
            <div class="clearfix"></div>
            <h3 class="inpagehed">Passenger Details</h3>
            <div class="card p-3 mt-3 sectionbuk" *ngFor="let p of flights?.PassengerDetails; let i = index">
                <div class="row">
                    <div class="col-12 d-flex w-100 justify-content-between capitalize">
                        <h5 class="mb-1">{{p.Title+' '+p.FirstName +' '+ p.LastName}}</h5>
                        <button type="button" class="btn btn-link" (click)="editPassengers()">Edit</button>
                    </div>
                    <hr class="my-2 w-100">
                    <div class="col-6">
                        <label>Date of Birth</label>
                        <p>{{ p.DateOfBirth | date:'mediumDate'}}</p>
                    </div>
                    <div class="col-6">
                        <label>Nationality</label>
                        <p>{{getCountryName(p.PassportIssuingCountry)}}</p>
                    </div>
                    <hr class="my-2 w-100">
                    <div class="col-6">
                        <label>Type</label>
                        <p style="text-transform: capitalize;">{{p.PassengerType}}</p>
                    </div>
                    <div class="col-6">
                        <label>ID Number</label>
                        <p>{{ p.PassportNumber }}</p>
                    </div>
                    <hr class="my-2 w-100">
                    <div class="col-6">
                        <label>Country of Issue</label>
                        <p>{{getCountryName(p.PassportIssuingCountry)}}</p>
                    </div>
                    <div class="col-6">
                        <label>Expiry Date</label>
                        <p>{{p.PassportExpiryDate | date}}</p>
                    </div>
                    <ng-container *ngIf="isSeatInfoNotEmpty && p?.SeatInfo && p?.SeatInfo.length>0">
                        <hr class="my-2 w-100">
                        <div class="col-12">
                            <label>Selected Seat</label>
                            <br/>
                            <ng-container *ngFor="let seat of p?.SeatInfo; let last = last">
                                <span>{{ seat.Code }} ({{ seat.FromAirportCode }}-{{seat.ToAirportCode}})</span>
                                    <ng-container *ngIf="!last">, </ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="clearfix"></div>
            <h3 class="inpagehed hide">Baggage Protection</h3>
            <div class="card p-3 mt-3 sectionbuk hide" *ngIf="baggageLoaded | async">
                <div class="row">
                    <div class="col-12 d-flex w-100 justify-content-between">
                        <h5 class="mb-1">For {{'BDT'}} {{baggagelist?.ProductPrice}} per traveller:</h5>
                    </div>
                    <hr class="my-2 w-100">
                    <div class="col-12">
                        <div class="form-row">
                            <div class="form-group col-md-12 form-group p-3 border rounded">
                                <p class="">
                                    <i class="fa fa-check text-success" aria-hidden="true"> </i>
                                    Blue Ribbon Bags will track and expedite your delayed bagage
                                </p>
                                <p class="">
                                    <i class="fa fa-check text-success" aria-hidden="true"> </i>
                                    Provides real-time push notifications via email or SMS regarding the status
                                    of your bagage
                                </p>
                                <p class="">
                                    <i class="fa fa-check text-success" aria-hidden="true"> </i>
                                    Receive {{'BDT'}} {{baggagelist.BagCoverage}} if your bag is not at the destination
                                    within 96 hours
                                </p>
                            </div>
                        </div>
                        <div class="form-row mt-1">
                            <form [formGroup]="baggageForm">
                                <div class="form-group col-md-12 nopad">
                                    <input formControlName="baggageProtection" [value]="true" type="radio" name=""
                                        id="yes" class="" (change)="updateBaggage(true)"> <label for="yes"
                                        class="text-info">
                                        &nbsp;Yes, add to my reservation <span class="text-success ml-3"> HIGHLY
                                            RECOMMENDED
                                        </span>
                                    </label>
                                </div>
                                <div class="form-group col-md-12 nopad">
                                    <input formControlName="baggageProtection" [value]="false" type="radio" name=""
                                        id="no" class="" (change)="updateBaggage(false)" [checked]="baggageRadio">
                                    <label for="no" class="text-info">
                                        &nbsp;No I'll run the risk
                                    </label>
                                </div>
                                <div class="">
                                    <small class="error text-danger"
                                        *ngIf="hasError('baggageProtection', 'required', 'baggageForm');">
                                        Please Select Baggage Protection Option* <br>
                                    </small>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <br>
            <div style="text-align: center;">
                <div class="position-relative row form-check">
                    <div class="col-sm-12">
                        <button type="button" class="btn btn-primary book_btn btn_hover"
                        (click)="onReservation()">Hold Ticket</button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn btn-primary book_btn btn_hover"
                            (click)="confirmBooking()">Confirm Ticket</button>
                        &nbsp;&nbsp;
                        <a routerLink="/"><button class="btn btn-success book_btn btn_hover">Cancel</button></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 pl-0 pl-4 pt-2 mobile_pad mobile_bot">
            <app-booking-fare-summary [flight]="flight" [showFlightDetails]="false"  [showTotalDisplayFare]="true" [convenienceFee]="convenienceFee"></app-booking-fare-summary>
        </div>
    </div>
</div>
</div>
<!-- <ngx-loading [show]="loading"
    [config]="{primaryColour: '#fff', secondaryColour: '#ccc', tertiaryColour: '#fff', backdropBorderRadius: '3px',fullScreenBackdrop:true}"
    [template]="loadingTemplate"></ngx-loading> -->